/* StatusPill — pill colorée inspirée du style image 3
   status: 'operational' | 'degraded' | 'down' | 'warning' | 'unknown'
   size:   'sm' | 'md'
*/

const CONFIG = {
  operational: {
    bg:     '#f0fdf4',
    border: '#bbf7d0',
    color:  '#15803d',
    dot:    '#16a34a',
    label:  'Opérationnel',
  },
  watch: {
    bg:     '#fffbeb',
    border: '#fde68a',
    color:  '#b45309',
    dot:    '#d97706',
    label:  'À surveiller',
  },
  critical: {
    bg:     '#fff5f5',
    border: '#fecaca',
    color:  '#b91c1c',
    dot:    '#dc2626',
    label:  'Critique',
  },
  degraded: {
    bg:     '#fff7ed',
    border: '#fed7aa',
    color:  '#c2410c',
    dot:    '#ea580c',
    label:  'Dégradé',
  },
  down: {
    bg:     '#fff5f5',
    border: '#fecaca',
    color:  '#b91c1c',
    dot:    '#dc2626',
    label:  'Injoignable',
  },
  warning: {
    bg:     '#fffbeb',
    border: '#fde68a',
    color:  '#b45309',
    dot:    '#d97706',
    label:  'Surveillance',
  },
  critical: {
    bg:     '#fff0f0',
    border: '#fca5a5',
    color:  '#b91c1c',
    dot:    '#ef4444',
    label:  'Critique',
  },
  unknown: {
    bg:     '#f9fafb',
    border: '#e5e7eb',
    color:  '#6b7280',
    dot:    '#9ca3af',
    label:  'Inconnu',
  },
};

function StatusPill({ status, label, size = 'md', pulse = false }) {
  const cfg = CONFIG[status] || CONFIG.unknown;
  const displayLabel = label || cfg.label;

  const dotSize  = size === 'sm' ? 6  : 8;
  const fontSize = size === 'sm' ? '0.68rem' : '0.78rem';
  const padding  = size === 'sm' ? '2px 8px'  : '4px 11px';

  return (
    <span
      style={{
        display:      'inline-flex',
        alignItems:   'center',
        gap:          6,
        padding,
        borderRadius: 99,
        background:   cfg.bg,
        border:       `1px solid ${cfg.border}`,
        color:        cfg.color,
        fontSize,
        fontWeight:   600,
        whiteSpace:   'nowrap',
        lineHeight:   1,
      }}
    >
      <span
        style={{
          width:        dotSize,
          height:       dotSize,
          borderRadius: '50%',
          background:   cfg.dot,
          flexShrink:   0,
          animation:    pulse ? 'pulse-dot 2s ease-in-out infinite' : 'none',
        }}
      />
      {displayLabel}
    </span>
  );
}

export function mapServerStatusToPill(serverStatus) {
  const lower = (serverStatus || '').toLowerCase();

  if (lower === 'hors ligne' || lower === 'injoignable') return 'down';
  if (lower === 'dégradé')                               return 'degraded';
  if (lower === 'opérationnel')                          return 'operational';
  return 'unknown';
}

export function mapMetricAlerteToPill(alerteLevel) {
  const level = parseInt(alerteLevel, 10);
  if (level === 4) return 'critical';
  if (level === 3) return 'degraded';
  if (level === 2) return 'warning';
  return 'operational';
}

export default StatusPill;
